import { TemaCard } from "../models/TemaCardModel";

export const connectorCards: TemaCard[] = [

    new TemaCard(
        'conj9',
        'Connectors & Conjunctions',
        'conjunction',
        'sin embargo',
        'however / nevertheless',
        'Used to contrast two ideas.',
        undefined,
        'Estaba cansado, sin embargo salió a correr.'
    ),

    new TemaCard(
        'conj10',
        'Connectors & Conjunctions',
        'conjunction',
        'a pesar de que',
        'despite the fact that / although',
        'Expresses contradiction.',
        undefined,
        'A pesar de que llovía, fuimos al parque.'
    ),

    new TemaCard(
        'conj11',
        'Connectors & Conjunctions',
        'conjunction',
        'es que...',
        'it’s just that...',
        'Common in spoken Spanish for softening explanations.',
        undefined,
        'No fui, es que tenía mucho trabajo.'
    ),

    new TemaCard(
        'conj12',
        'Connectors & Conjunctions',
        'conjunction',
        'en plan...',
        'like / kind of / basically...',
        'Informal filler used to explain or clarify something.',
        undefined,
        'Estaba en plan “no quiero hablar más”.'
    ),

    new TemaCard(
        'conj13',
        'Connectors & Conjunctions',
        'conjunction',
        'ya que',
        'since / because',
        'Introduces reasoning or justification.',
        undefined,
        'Ya que no tienes clases, podrías venir conmigo.'
    ),

    new TemaCard(
        'conj14',
        'Connectors & Conjunctions',
        'conjunction',
        'aunque parezca mentira',
        'believe it or not',
        'Used to express something surprising or unexpected.',
        undefined,
        'Aunque parezca mentira, me encanta madrugar.'
    ),

    new TemaCard(
        'conj15',
        'Connectors & Conjunctions',
        'conjunction',
        'por lo tanto',
        'therefore / thus',
        'Indicates logical consequence.',
        undefined,
        'No estudió, por lo tanto suspendió el examen.'
    )
]